import React from 'react';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { connect } from 'react-redux';
import { Link } from '@reach/router';

import LoginIcon from './assets/login.svg';

const SignInIconButton = ({ hide }) => {
  if (hide) return null;

  return (
    <Link to="/signin">
      <img height={40} width={40} src={LoginIcon} alt="login-icon" />
    </Link>
  );
};

const mapStateToProps = state => ({
  hide: !isEmpty(get(state, ['user', 'userId'], '')),
});

export default connect(mapStateToProps)(SignInIconButton);
